import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';




const PoliticaCancelamentoAHA: React.FC = () => {



  return (
    <>
      <ContainerWhite id="cancelamento">

        <div className="p50  ">
          <h2 style={{ fontSize: '24px', lineHeight: '28px' }}>POLÍTICA DE CANCELAMENTO, REEMBOLSO E REMARCAÇÃO</h2>
          <h2 style={{ fontSize: '18px', lineHeight: '22px' }}>Cursos AHA (BLC, ACLS e PALS)</h2>
        </div>
        <div className="separator" />
        <h2>DA REMARCAÇÃO POR PEDIDO DO ALUNO</h2>
        <div className="p50  ">


          <p>
            A remarcação da data para participação em futuras turmas, solicitada pelo aluno e diferente da turma na qual se inscreveu inicialmente, pode ser realizada até duas vezes, desde que acompanhada de uma justificativa desde que até 72 horas antes da realização do curso. A remarcação do curso pela instituição não será considerada como remarcação por solicitação do aluno.  </p>
        </div>
        <div className="separator" />
        <h2>DO CANCELAMENTO E REEMBOLSO POR PEDIDO DO ALUNO</h2>
        <div className="p50  ">


          <p>

            Os pedidos de cancelamento serão aceitos somente mediante formalização por e-mail para ensino@fundmed.org.br, fornecendo os dados de inscrição, até 10 (dez) dias antes do início do evento. O reembolso será processado em até 30 dias após a data da ocorrência do curso, com uma retenção de 30% do valor pago. Não será concedido reembolso para solicitações de cancelamento feitas após o prazo de 10 dias antes do início do curso selecionado no momento da inscrição, nem em caso de não comparecimento ao evento. Não serão efetuados reembolsos que não estejam em conformidade com as normas estabelecidas. Quaisquer despesas bancárias relacionadas serão de responsabilidade do solicitante.
            <br /><br />

            <strong>📢 Os cursos serão realizados mediante a número mínimo de participantes.</strong>

          </p>
        </div>
      </ContainerWhite>
    </>
  );
};
export default PoliticaCancelamentoAHA;
